import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { fullMonthDayYearDateFormat } from '@/modules/core/app/helpers/DateHelper';
import { HubSpotLineItem } from '@/modules/hubspot/models/HubSpotLineItem';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class EstateProduct extends BaseEntityModel {
  id: number;
  estateId: number;
  productKey: ProductKey;
  sourceType:
    | ModelType.USER
    | ModelType.DEFAULT_PARTNER_PRODUCT
    | ModelType.PARTNERSHIP_INVITATION
    | null;
  sourceId: number | null;
  hubspotLineItemId: number;
  price?: number;
  cancelAt?: string;
  isAddOn?: boolean;
  hubspotLineItem?: Relationship<HubSpotLineItem> | null;
  // not in resource
  checkoutSessionId?: string;

  /**
   * since this will NEVER be created on the frontend `model` MUST contain all props
   * @param model
   */
  constructor(model: Partial<EstateProduct> = {}) {
    super(model);

    this.id = model.id as number;
    this.estateId = model.estateId as number;
    this.productKey = model.productKey as ProductKey;
    this.sourceType = model.sourceType!;
    this.sourceId = model.sourceId!;
    this.hubspotLineItemId = model.hubspotLineItemId as number;
    this.price = model.price;
    this.cancelAt = model.cancelAt;
    this.isAddOn = model.isAddOn;
    this.checkoutSessionId = model.checkoutSessionId;

    this.hubspotLineItem = HubSpotLineItem.mapModelOrNull(model.hubspotLineItem);
  }

  get formattedCancelAt(): string | null {
    return this.cancelAt ? fullMonthDayYearDateFormat(this.cancelAt) : null;
  }

  wasPaidForByUser(userId: number): boolean {
    return this.sourceType === ModelType.USER && this.sourceId === userId;
  }

  get isStandardPlan(): boolean {
    return [ProductKey.INDIVIDUAL_STANDARD_PLAN, ProductKey.COUPLES_STANDARD_PLAN].includes(
      this.productKey
    );
  }

  get isBasicPlan(): boolean {
    return [ProductKey.INDIVIDUAL_BASIC_PLAN, ProductKey.COUPLES_BASIC_PLAN].includes(
      this.productKey
    );
  }

  get isPaidSaaS(): boolean {
    return (
      this.sourceType === ModelType.DEFAULT_PARTNER_PRODUCT ||
      this.sourceType === ModelType.PARTNERSHIP_INVITATION
    );
  }
}
